import { render, staticRenderFns } from "./TheHightlightsList.vue?vue&type=template&id=29dbce42&scoped=true&"
import script from "./TheHightlightsList.vue?vue&type=script&lang=js&"
export * from "./TheHightlightsList.vue?vue&type=script&lang=js&"
import style0 from "./TheHightlightsList.vue?vue&type=style&index=0&id=29dbce42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbce42",
  null
  
)

export default component.exports